import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from '../store'
import client from '../../api/config'
import { Article, SupportArticlesState } from './supportArticlesType'

const initialState: SupportArticlesState = {
    articles: null,
}

const supportArticlesSlice = createSlice({
    name: 'supportArticles',
    initialState,
    reducers: {
        setArticles: (state, action: PayloadAction<Article[]>) => {
            state.articles = action.payload
        },
        deleteArticle: (state, action: PayloadAction<{ articleId: string }>) => {
            const index = state.articles.findIndex(
                (article) => article._id === action.payload.articleId
            )
            state.articles = [
                ...state.articles.slice(0, index),
                ...state.articles.slice(index + 1),
            ]
        },
        updatedArticle: (
            state,
            action: PayloadAction<{ articleId: string; update: Partial<Article> }>
        ) => {
            const index = state.articles.findIndex(
                (articles) => articles._id === action.payload.articleId
            )

            state.articles = [
                ...state.articles.slice(0, index),
                {
                    ...state.articles[index],
                    ...action.payload.update,
                },
                ...state.articles.slice(index + 1),
            ]
        },
    }
})

export const { setArticles, deleteArticle, updatedArticle } =
    supportArticlesSlice.actions

export default supportArticlesSlice.reducer

export const fetchArticles =
    (): AppThunk<Promise<void>> => async (dispatch, getState) => {

        try {
            await client
                .get('/articles')
                .then((response) => {
                    dispatch(setArticles(response.data))
                    return response.data
                })
                .catch((err) => {
                    console.log('ERROR : ', err)
                })
        } catch (e) {
            console.log('ERROR : ', e)
        }
    }

export const updateArticle =
    (formData): AppThunk<Promise<void>> => async (dispatch, getState) => {
        try {
            await client
                .put('/articles', formData)
                .then((response) => {
                    dispatch(updatedArticle({ articleId: formData._id, update: formData }))
                    return response.data
                })
                .catch((err) => {
                    console.log('ERROR : ', err)
                })
        } catch (e) {
            console.log('ERROR : ', e)
        }
    }

export const fetchAllArticles =
    (): AppThunk<Promise<void>> => async (dispatch, getState) => {

        try {
            await client
                .get('/articles-all')
                .then((response) => {
                    dispatch(setArticles(response.data))
                    return response.data
                })
                .catch((err) => {
                    console.log('ERROR : ', err)
                })
        } catch (e) {
            console.log('ERROR : ', e)
        }
    }

export const createNewArticle =
    (formData: Article): AppThunk<Promise<void>> => async (dispatch, getState) => {
        try {
            const article = await client
                .post('/articles', formData)
                .then((response) => {
                    return response.data
                })
                .catch((err) => {
                    console.log('ERROR : ', err)
                    return []
                })
            return article
        } catch (e) {
            console.log('ERROR : ', e)
            return {}
        }
    }

export const fetchDeleteArticle = (
    articleId: string,
): AppThunk<Promise<void>> =>
    async (dispatch, getState) => {
        try {
            const deletedArticle = await client
                .delete(`/articles/${articleId}`)
                .then((response) => {
                    dispatch(deleteArticle({ articleId }))
                    return response.data
                })
                .catch((err) => {
                    console.log('ERROR : ', err)
                    return []
                })
            return deletedArticle
        } catch (e) {
            console.log('ERROR : ', e)
            return {}
        }
    }
